module.exports = __webpack_public_path__ + "img/scene_11.5ce71909.jpg";